module.exports = __webpack_public_path__ + "risk-1f457ec9951a60d7717f14a52649eec7.svg";